import { Button, Spinner, Typography } from '@material-tailwind/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TableLayout from '../../../layouts/pagesLayouts/TableLayout'
import GraphConsumption from './GraphConsumption'
import { useViewConsumptionMonthQuery } from '../../../store/auth/authService'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import FilterByMonth from './FilterByMonth' 
import { isIterableArray, saveGraphToPicture, toFormatPrice, toStringPrice } from '../../../utils/utils'
import { classCharContainerHeight, isShowInLegend, dayFormatFilter, dayFormatView, monthFormatChange, monthFormatFilter, monthFormatView, isData } from '../common'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import axios from 'axios'
import { baseApi } from '../../../ConfigApi'
import { errorToast } from '../../../components/toasts/toasts'
import fileDownload from 'js-file-download'
import { chartColors } from '../../../utils/variables'
import { ConsByMonthFormType } from '../common.types'

const GRAPH_ID = "js-cons-by-month-graph"
// export const GRAPH_TARIF_MONTH = "js-tarif-by-month-graph"
// export const GRAPH_PRICE_MONTH = "js-price-by-month-graph"

const ViewByMonth = ({ setPeriodMonth, setPeriodDay, periodMonth, isMobile }: {
    setPeriodMonth: any,
    setPeriodDay: any,
    periodMonth: string,
    isMobile: boolean
}) => {
    const { t } = useTranslation()
    const { param_contract_id } = useParams<{
        param_contract_id: string;
    }>()

    const { token } = useSelector((state: RootState) => state.auth)
    const { or_number } = useSelector((state: RootState) => state.contract)


    const [sendForm, setSendForm] = useState<ConsByMonthFormType>({
        contract_id: Number(param_contract_id) || 0,
        period: periodMonth,
    });

    const { currentData, error, isFetching } = useViewConsumptionMonthQuery<any>(sendForm, {
        skip: periodMonth === '',
    })

    const uniqueKeys = currentData?.legendKeys?.map((i: string) => {
        return ({
            key: i,
            show: true,
        })
    })
    const [legend, setLegend] = useState([]);
    useEffect(() => {
        if (isIterableArray(uniqueKeys) && !isIterableArray(legend)) {
            setLegend(uniqueKeys)
        }
    }, [uniqueKeys, legend]);



    useEffect(() => {
        setSendForm({
            contract_id: Number(param_contract_id) || 0,
            period: periodMonth,
        })
    }, [periodMonth]);

    const handleClickGraph = (index: number, el: any) => {
        const day = currentData?.formatted?.labels?.[index]
        setPeriodDay(`${day}-${periodMonth}`)
    }

    const setFormForFetch = (values: any) => {
        setPeriodMonth(values.period)
        setSendForm(prev => ({
            ...prev, ...{
                ...values,
                contract_id: param_contract_id
            }
        }))
    }

    const datachar = useCallback(
        () => {
            const data = currentData?.formatted
            if (!data) return
            const datasets = []
            if (isData(data.declared) && isShowInLegend(legend, 'declared')) datasets.push({
                animation: false,
                transitions: false,
                order: 1,
                label: t('analytics.declared'),
                data: data.declared,
                data_origin: data.declared_origin,
                backgroundColor: chartColors.declared,
                borderRadius: 4,
                spanGaps: false,
                stack: 'Stack1',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    rotation: '-90',
                    anchor: 'center',
                    formatter: function (_: any, context: any) {
                        const origin_value = context?.dataset?.data_origin?.[context?.dataIndex]
                        return `${toStringPrice(origin_value)}`;
                    },
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#FDFDFD';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }

            })
            if (isData(data.declared_delta_less_6) && isShowInLegend(legend, 'declared_delta_less_6')) datasets.push({
                animation: false,
                transitions: false,
                order: 2,
                label: t('analytics.declared_delta_less_6'),
                data: data.declared_delta_less_6,
                backgroundColor: chartColors.declared_delta_less_6,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack1',
                datalabels: {
                    display: false,
                }
            })
            if (isData(data.declared_delta_more_6) && isShowInLegend(legend, 'declared_delta_more_6')) datasets.push({
                animation: false,
                transitions: false,
                order: 2,
                label: t('analytics.declared_delta_more_6'),
                data: data.declared_delta_more_6,
                backgroundColor: chartColors.declared_delta_more_6,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack1',
                datalabels: {
                    display: false,
                }
            })
            if (isData(data.fact) && isShowInLegend(legend, 'fact')) datasets.push({
                animation: false,
                transitions: false,
                order: 1,
                label: t('analytics.fact'),
                data: data.fact,
                backgroundColor: chartColors.fact,
                borderRadius: 4,
                spanGaps: true,
                stack: 'Stack2',
                datalabels: {
                    display: !isMobile,
                    align: 'center',
                    rotation: '-90',
                    anchor: 'center',
                    formatter: function (value: any) {
                        return `${toStringPrice(value)}`;
                    },
                    color: function (context: any) {
                        if (!context?.dataset?.data?.[context?.dataIndex]) return '#00000000'
                        return '#444248';
                    },
                    font: {
                        weight: 500,
                        size: 10,
                        family: 'Inter'
                    }
                }
            })
            if (data) return {
                labels: data?.labels,
                datasets: datasets,
            }
        },
        [currentData?.formatted, legend],
    )

    const titleTooltipFormatter = (val: string) => {
        return moment(`${val}-${periodMonth}`, dayFormatFilter).format(dayFormatView)
    }

    const saveExcel = (callback?: any) => {
        axios.post(`${baseApi}/api/analitic/build-excel-report-type-8`, {
            ...sendForm,
            typeReport: 8,
        },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': token,
                }
            })
            .then((response: any) => {
                if (response.data.res === 'Error') {
                    errorToast({
                        title: t('analytics.build_excel_report'),
                        text: t('analytics.build_excel_report_error')
                    })
                }
                else {
                    fileDownload(response.data, `${t('analytics.build_excel_report_8')} ${sendForm.period}.xlsx`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('analytics.build_excel_report'),
                    text: t('analytics.build_excel_report_error')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }

    return (
        // ${(periodMonth && !periodDay) ? 'opacity- 1 block' : 'opacity- 0 hidden'}
        <div className={`  transition-opacity delay-[150ms] duration-[250ms]`}>


            <FilterByMonth
                formatView={monthFormatView}
                formatFilter={monthFormatFilter}
                formatChange={monthFormatChange}
                value={{
                    period: periodMonth,
                }}
                isLoadingFetch={isFetching}
                fetchPage={setFormForFetch}
                savePicture={() => {
                    saveGraphToPicture(GRAPH_ID, `${t('or')} ${or_number} - ${t('analytics.analytics_cons_by_month_title')} ${t('by_period')} ${periodMonth}.png`)
                }}
                saveExcel={saveExcel}
                isForSave={!!currentData?.isForSave}
            />

            <div className='h-full'>
                {
                    currentData?.formatted ?
                        <>
                            <div className='h-full bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px]'>
                                <Typography variant='lead' className='text-gray-800 text-center mb-[24px] tab:mb-[32px] text-[20px] lap:text-[24px] text-left'>
                                    {t('analytics.analytics_cons_by_month_title')} {moment(periodMonth, 'MM-YYYY').format('MMMM')}
                                </Typography>
                                <div className={classCharContainerHeight}>
                                    <GraphConsumption
                                        graphId={GRAPH_ID}
                                        titleTooltipFormatter={titleTooltipFormatter}
                                        handleClickGraph={handleClickGraph}
                                        datachar={datachar()}
                                        fixedCount={0}
                                    />
                                </div>
                                {
                                    !!currentData?.isForSave &&
                                        (isIterableArray(uniqueKeys) && isIterableArray(legend))
                                        ?
                                        <div className='mt-[24px] flex gap-[8px] lap:gap-x-[16px] flex-wrap justify-start'>
                                            {
                                                legend.map((item: any, index: number) => (
                                                    <div key={index} className='flex gap-[2px] items-center cursor-pointer' onClick={() => {
                                                        setLegend((prev: any) => prev.map((i: any) => ({
                                                            ...i,
                                                            show: item.key === i.key ? !i.show : i.show
                                                        })))
                                                    }}>
                                                        <span className={`block rounded w-[10px] h-[10px]  `} style={{ backgroundColor: item.show ? chartColors?.[item.key] : '#eee' }}></span>
                                                        <Typography variant='lead' className={`${item.show ? 'text-gray-700' : 'text-gray-400'}  font-medium text-[12px] lap:text-[14px]`}>
                                                            {t(`analytics.${item.key}`)}
                                                        </Typography>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        :
                                        <div className='min-h-[45px]' />
                                }
                            </div>
                        </>
                        :
                        isFetching ?
                            <div className={`${classCharContainerHeight}  bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] flex justify-center items-center`}>
                                <Spinner />
                            </div>
                            :
                            error ?
                                <TableLayout>
                                    <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                        {t('tables.error_on_loading')}
                                    </Typography>
                                </TableLayout>
                                :
                                ''
                }
            </div>
        </div>
    )
}

export default ViewByMonth